import _ from 'lodash';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from '../reducers/index';

let reduxStoreInstance = null;
const setStoreInstance = (instance) => {
  reduxStoreInstance = instance;
};

export default function configureStore(initialState = {}) {
  if (!_.isNil(reduxStoreInstance)) return reduxStoreInstance;

  const middleware = [thunk];

  const store = createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
  );

  if (import.meta.hot) {
    import.meta.hot.accept('../reducers', (nextRootReducer) => {
      store.replaceReducer(nextRootReducer);
    });
  }

  setStoreInstance(store);
  return store;
}

export const store = configureStore();
